import { FC } from 'react';

import {
  CLIMATE_RISK_FACT_TYPES,
  ClimateRiskRatingOrder,
  PlotReportFactLabelNameEnum,
  Scenario,
} from '@/api/rest/resources/types/fact';
import { WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useOrganizationIndicatorReportingFact } from '@/pages/shared/hooks/useOrganizationFact';
import { isNullish } from '@/utils/booleans';
import { safeRiskIndexToRating } from '@/utils/climateRisk';

export const RisksTile: FC = () => {
  const facts = useOrganizationIndicatorReportingFact<number>(Object.keys(CLIMATE_RISK_FACT_TYPES), null, {
    [PlotReportFactLabelNameEnum.scenario]: Scenario.baseline,
  });

  const risks = Object.keys(facts)
    .filter((factType) => {
      const risk = facts[`${factType}`];
      return !isNullish(risk?.value);
    })
    .map((factType) => facts[`${factType}`])
    .sort((a, b) => {
      const aRating = safeRiskIndexToRating(a?.value as number);
      const bRating = safeRiskIndexToRating(b?.value as number);
      // eslint-disable-next-line security/detect-object-injection
      return ClimateRiskRatingOrder[aRating] > ClimateRiskRatingOrder[bRating] ? -1 : 1;
    })
    .map((fact) => fact?.name);
  const riskOverviewConfig = {
    name: 'climate_risk_overview',
    type: WidgetType.o_c_risk_overview,
    visible: true,
    relatedData: {
      className: 'flex flex-row flex-wrap gap-4',
      risks,
    },
  };

  return (
    <div className='mb-10'>
      <WidgetSlotRenderer nestedWidget={riskOverviewConfig} />
    </div>
  );
};
